import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get user tester List
export const getUserTesterlist = createAsyncThunk(
  "getUserTesterlist",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(
        `/subscription/get-free-user${queryString}`
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const editUserTester = createAsyncThunk(
  "editUserTester",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(
        `/subscription/free-user-subscription`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const testerSlice = createSlice({
  name: "tester",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get user tester list
      .addCase(getUserTesterlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserTesterlist.fulfilled, (state, action) => {
        state.loading = false;
        state.getUserTesterlistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getUserTesterlist.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //Edit subscription for user tester
      .addCase(editUserTester.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUserTester.fulfilled, (state, action) => {
        state.loading = false;
        state.editUserTesterStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editUserTester.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
  },
});

export const { setTester } = testerSlice.actions;
export default testerSlice.reducer;
